import GoogleClientBase from "./GoogleClientBase";
import { googleJson } from "./request";

class Document extends GoogleClientBase {
  getLink(fileId: string): string {
    return `https://docs.google.com/document/d/${fileId}`;
  }

  async create(title: string): Promise<string> {
    const response = await googleJson<{ documentId?: string }>("https://docs.googleapis.com/v1/documents", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title }),
    });

    const { documentId } = response;

    if (!documentId) {
      throw new Error("Google Document created with empty ID.");
    }

    return documentId;
  }
};

export default new Document();
